const he = {
  // Navigation
  'nav.dashboard': 'לוח בקרה',
  'nav.calendar': 'לוח שנה',
  'nav.statistics': 'סטטיסטיקות',
  'nav.callLog': 'יומן שיחות',
  'nav.habits': 'הרגלים',
  'nav.settings': 'הגדרות',
  'nav.admin': 'ניהול',
  'nav.signOut': 'התנתק',

  // App
  'app.title': 'זמן',
  'app.subtitle': 'CodeLab',

  // Auth
  'auth.login': 'התחברות',
  'auth.signup': 'הרשמה',
  'auth.email': 'אימייל',
  'auth.password': 'סיסמה',
  'auth.fullName': 'שם מלא',
  'auth.forgotPassword': 'שכחת סיסמה?',
  'auth.resetPassword': 'איפוס סיסמה',
  'auth.sendResetLink': 'שלח קישור לאיפוס',
  'auth.backToLogin': 'חזרה להתחברות',
  'auth.resetEmailSent': 'אם קיים חשבון עבור אימייל זה, נשלח קישור לאיפוס סיסמה.',
  'auth.newPassword': 'סיסמה חדשה',
  'auth.confirmPassword': 'אימות סיסמה',
  'auth.updatePassword': 'עדכן סיסמה',
  'auth.passwordUpdated': 'הסיסמה עודכנה. כעת ניתן להתחבר.',

  // Dashboard
  'dashboard.todayStatus': 'סטטוס היום',
  'dashboard.morningReminder': 'תזכורת בוקר',
  'dashboard.bedtimeReminder': 'תזכורת לילה',
  'dashboard.streak': 'רצף',
  'dashboard.currentStreak': 'רצף נוכחי',
  'dashboard.longestStreak': 'הרצף הארוך ביותר',
  'dashboard.zmanim': 'זמנים',
  'dashboard.sunsetIn': 'שקיעה בעוד',
  'dashboard.upcomingReminders': 'תזכורות קרובות',
  'dashboard.weeklyBreakdown': 'פילוח שבועי',
  'dashboard.monthlyTrend': 'מגמה חודשית',

  // Statuses
  'status.onTime': 'בזמן',
  'status.early': 'מוקדם',
  'status.late': 'באיחור',
  'status.missed': 'הוחמץ',
  'status.pending': 'ממתין',
  'status.shabbat': 'שבת',
  'status.holiday': 'חג',

  // Settings
  'settings.title': 'הגדרות',
  'settings.language': 'שפת תצוגה',
  'settings.languageRegion': 'שפה ואזור',
  'settings.timezone': 'אזור זמן',
  'settings.shabbatMode': 'מצב שבת',
  'settings.holidayMode': 'מצב חג',
  'settings.save': 'שמור שינויים',
  'settings.saved': 'ההגדרות נשמרו',

  // Common
  'common.loading': 'טוען...',
  'common.today': 'היום',
  'common.cancel': 'ביטול',
  'common.confirm': 'אישור',
  'common.close': 'סגור',
  'common.search': 'חיפוש',
  'common.noData': 'אין נתונים זמינים',

  // Jewish calendar
  'jewish.shabbatShalom': 'שבת שלום',
  'jewish.chagSameach': 'חג שמח',
  'jewish.candleLighting': 'הדלקת נרות',
  'jewish.havdalah': 'הבדלה',
  'jewish.parshat': 'פרשת',
  'jewish.roshChodesh': 'ראש חודש',

  // Pricing
  'pricing.title': 'בחרו את התוכנית שלכם',
  'pricing.subtitle': 'שיחות תזכורת אוטומטיות שבאמת בונות הרגלים.',
  'pricing.planName': 'אישי',
  'pricing.price': '$7',
  'pricing.perMonth': '/לחודש',
  'pricing.trialNote': 'התחילו עם 7 ימי ניסיון חינם. ניתן לבטל בכל עת.',
  'pricing.feature.calls': 'שיחות תזכורת יומיות אוטומטיות',
  'pricing.feature.habits': 'הרגלים ולוחות זמנים ללא הגבלה',
  'pricing.feature.streaks': 'מעקב רצפים וסטטיסטיקות',
  'pricing.feature.zmanim': 'לוח עברי וזמנים מלאים',
  'pricing.feature.multilang': 'אנגלית, עברית ויידיש',
  'pricing.startTrial': 'התחילו 7 ימי ניסיון חינם',
  'pricing.processing': 'מעביר...',

  // Subscription (settings)
  'subscription.title': 'מנוי',
  'subscription.status': 'סטטוס',
  'subscription.plan': 'תוכנית',
  'subscription.renews': 'מתחדש',
  'subscription.trialEnds': 'הניסיון מסתיים',
  'subscription.cancelsOn': 'מבוטל בתאריך',
  'subscription.manageBilling': 'ניהול חיוב',
  'subscription.subscribe': 'הרשמה',
  'subscription.none': 'אין לך מנוי פעיל.',
  'subscription.status.active': 'פעיל',
  'subscription.status.trialing': 'ניסיון',
  'subscription.status.past_due': 'תשלום באיחור',
  'subscription.status.canceled': 'בוטל',
  'subscription.status.incomplete': 'לא הושלם',
  'subscription.status.unpaid': 'לא שולם',

  // Admin billing toggle
  'admin.billing.title': 'חיוב',
  'admin.billing.toggle': 'הפעל מנויים בתשלום',
  'admin.billing.help': 'כשכבוי, האפליקציה חינמית לחלוטין והשיחות פועלות לכל המשתמשים. כשמופעל, רק מנויים מקבלים שיחות.',
  'admin.billing.on': 'פועל',
  'admin.billing.off': 'כבוי',
};

export default he;
